import { ComposedChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, Line, LineChart, ResponsiveContainer, LabelList } from 'recharts';

type chartDataInvoiceTypes = Array<{
  month: string;
  jobs: number;
  quotes: number;
  jobsPreviousYear: number;
  quotesPreviousYear: number;
}>

const MainQuoteWorkChart = (props: {onChartData: chartDataInvoiceTypes}) => (
  <ResponsiveContainer width="100%" height={280}>
    <ComposedChart style={{maxWidth: "100%"}} width={1000} height={400} data={props.onChartData}>

      <defs>
        <linearGradient id="colorQuote" x1="0" y1="0" x2="0" y2="1">
          <stop offset="5%" stopColor="#1e2a4e" stopOpacity={0.8}/>
          <stop offset="95%" stopColor="#0a1229" stopOpacity={0.8}/>
        </linearGradient>
        <linearGradient id="colorQuotePrevious" x1="0" y1="0" x2="0" y2="1">
          <stop offset="5%" stopColor="#91B4D3" stopOpacity={0.8}/>
          <stop offset="95%" stopColor="#91B4D3" stopOpacity={0.8}/>
        </linearGradient>
      </defs>

      <CartesianGrid strokeDasharray="3 3" />

      <XAxis tick={{ fontSize: "9pt", fill: "rgb(30, 42, 78)" }} dataKey="month"  tickMargin={10}/>
      <YAxis tick={{ fontSize: "9pt", fill: "rgb(30, 42, 78)" }} tickMargin={10}/>

      <Tooltip
        contentStyle={{
          backgroundColor: 'rgba(255, 255, 255, 0.7)', 
          borderColor: 'rgba(150, 150, 150, 0.8)',     
          color: 'rgb(138 137 179)'                              
        }}
        itemStyle={{ color: 'black' }}
        labelStyle={{ color: 'black' }}
      />

      <Legend
        content={({ payload }) => (
          <ul style={{
            listStyle: 'none',
            display: 'flex',
            margin: '1em 0 0 0',
            padding: 0,
            justifyContent: 'center',
          }}>
            {
              payload?.map((entry, index) => (
                <li key={`item-${index}`} style={{ marginRight: 10, display: 'flex', alignItems: 'center' }}>
                  <svg height="14" width="14">
                    <rect width="14" height="14" style={{ fill: entry.color }} />
                  </svg>
                  <span style={{ marginLeft: 5, fontSize: '9pt', color: 'black' }}>{entry.value}</span>
                </li>
              ))
            }
          </ul>
        )}
      />
      
      <Bar dataKey="quotesPreviousYear" fill="url(#colorQuotePrevious)" name="Quotes Previous Year">
        <LabelList 
          dataKey="quotesPreviousYear" 
          position="top"
          
          style={{ fill: 'rgb(138 137 179)', fontSize: "9pt", fontWeight: "bold" }} />
      </Bar>
      <Bar dataKey="quotes" fill="url(#colorQuote)" name="Quotes This Year">
        <LabelList 
          dataKey="quotes" 
          position="top" 
          style={{ fill: 'rgb(138 137 179)', fontSize: "9pt", fontWeight: "bold" }} />
      </Bar>
    </ComposedChart>
  </ResponsiveContainer>
);

export default MainQuoteWorkChart;
